import { NotImplementedError } from "@greeter/error";
import React, { useContext } from "react";

type InputSectionContext = {
  open: boolean;
  disabled: boolean;
  invalid: boolean;
  toggle: () => void;
};
const InputSectionContext = React.createContext<InputSectionContext>({
  open: false,
  disabled: false,
  invalid: false,
  toggle: () => {
    throw new NotImplementedError();
  },
});

export function useInputSectionContext() {
  return useContext(InputSectionContext);
}

export function InputSectionProvider(
  props: React.PropsWithChildren & { value: InputSectionContext }
) {
  return (
    <InputSectionContext.Provider value={props.value}>
      {props.children}
    </InputSectionContext.Provider>
  );
}
